import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@material-ui/core";

import { DynamicFormField } from "../../../../../../../../../@types/dynamicForm.types";
import { AuthContext, UIContext } from "../../../../../../../../../contexts";
import ExtractRouteParams from "../../../../../../../../../utils/commonFunctions/extractRouteParams";
import { Member } from "../../../../../../../../../@types/member.types";
import { handleSSNFormat } from "../../../../../../../../../utils/commonFunctions/SSN";
import initCapitalize from "../../../../../../../../../utils/commonFunctions/initCapitalize";
import { mongoDBDateParserToUSAFormat } from "../../../../../../../../../utils/commonFunctions/date";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../../../../../constants/caption/dashboardHeader";
import DynamicInformationForm from "../../../../../../../../shared/dynamicInformationForm/DynamicInformationForm";

import LockIcon from "@material-ui/icons/Lock";
import CreateIcon from "@material-ui/icons/Create";

import "./dependentSettings.css";

type DependentSettingsProps = {
	member: Member;
};

const DependentSettings: React.FC<DependentSettingsProps> = ({ member }): JSX.Element => {
	const [memberDetails, setMemberDetails] = useState<DynamicFormField[]>([]);
	const { user } = useContext(AuthContext);
	const { setDashboardHeader } = useContext(UIContext);
	const routeParam = ExtractRouteParams();
	const navigate = useNavigate();

	// console.log("dependent_details_", member);

	const handleRedirectResetPassword = useCallback(() => {
		const pathname = `/employer/member/change-password?${routeParam}`;
		navigate(pathname);
		// alert("Feature is yet to Live!");
	}, [navigate, routeParam]);

	const handleRedirectEditInformation = useCallback(() => {
		const pathname = `/employer/member/dependent/edit-member-settings?${routeParam}`;
		navigate(pathname);
	}, [navigate, routeParam]);

	useEffect(() => {
		setMemberDetails(
			Object.assign(
				[],
				[
					{
						label: "Username",
						name: "user_name",
						value: member.user_name ? member.user_name : "N/A",
						onChange: () => null,
						type: "textfield"
					},
					{
						label: "Email",
						name: "email",
						onChange: () => null,
						value: member.email,
						type: "textfield"
					},
					{
						label: "SSN",
						name: "SSN",
						onChange: () => null,
						value: handleSSNFormat(user, member.SSN),
						type: "textfield"
					},
					{
						label: "Upload Type",
						name: "upload_type",
						onChange: () => null,
						value: initCapitalize(member.upload_type),
						type: "textfield"
					},
					{
						label: "Last Login",
						name: "last_login",
						onChange: () => null,
						value: member.last_login_date
							? mongoDBDateParserToUSAFormat(member.last_login_date as unknown as string)
							: "Not Yet Logged In",
						type: "textfield"
					}
				]
			)
		);
	}, [member, user]);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.dependent_settings);
	}, [setDashboardHeader]);

	return (
		<div className="member-settings-container" id="member-settings-container">
			<div className="member-action-button-container" id="pf-action-button-container">
				<Button className="button-green" onClick={handleRedirectResetPassword} variant="contained">
					<span className="button-label-with-icon">Change Password</span>
					<span>
						<LockIcon className="button-icon" />
					</span>
				</Button>
			</div>

			<div className="pf-title">Dependent Informations</div>

			<div className="pf-action-button-container" id="pf-action-button-container">
				<Button className="button-black" onClick={handleRedirectEditInformation} variant="contained">
					<span className="button-label-with-icon">Edit</span>
					<span>
						<CreateIcon className="button-icon" />
					</span>
				</Button>
			</div>
			<div className="dynamic-form-container" id="dynamic-form-container">
				{memberDetails !== undefined ? <DynamicInformationForm informationFormData={memberDetails} /> : null}
			</div>
		</div>
	);
};

export default DependentSettings;
